import type { ProductPriceProps } from '@maestro/commerce-blocks/components/product-price/product-price.types'

import { useMemo } from 'react'

export const useProductPrice = (props: ProductPriceProps) => {
  const { price } = props

  const isDiscountedPrice = useMemo(() => {
    return (
      price?.discountedAmount !== undefined &&
      price?.amount !== price?.discountedAmount
    )
  }, [price?.discountedAmount, price?.amount])

  const isMemberPrice = useMemo(() => {
    return (
      price?.memberAmount !== undefined && price?.amount !== price?.memberAmount
    )
  }, [price?.memberAmount, price?.amount])

  return {
    isDiscountedPrice,
    isMemberPrice,
  }
}
